import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Message box used by the login, sign-up and password forms. */
@Component({
  selector: 'app-auth-alert',
  standalone: true,
  template: `
    <div
      [attr.role]="tone() === 'error' ? 'alert' : 'status'"
      class="flex items-start gap-3 rounded-2xl border p-4 text-sm font-semibold"
      [class]="tone() === 'error'
        ? 'border-red-100 bg-red-50 text-red-700 dark:border-red-800 dark:bg-red-900/20 dark:text-red-300'
        : 'border-emerald-100 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300'">
      <svg class="mt-0.5 h-5 w-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        @if (tone() === 'error') {
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        } @else {
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        }
      </svg>
      <div class="min-w-0 flex-1"><ng-content /></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthAlertComponent {
  tone = input<'error' | 'success'>('error');
}
